<template>
  <div>
    <my-header/>

    <div class="page">
      <b-breadcrumb>
        <b-breadcrumb-item :to="{name:'derby_list'}">Скачки</b-breadcrumb-item>
        <b-breadcrumb-item :to="{name:'derby_info'}">Скачки {{derbyId}}</b-breadcrumb-item>
      </b-breadcrumb>

      <h2>Игрок {{playerId}} (участник скачек)</h2>

      <div class="section-container">
        <side-nav
          :menuItems="menuItems"
          class="side-nav"
        />

        <router-view></router-view>
      </div>

    </div>
  </div>
</template>

<script>
import MyHeader from '../Header.vue';
import SideNav  from '../SideNav.vue';

export default {
  name: 'DerbyPlayer',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    derbyPlayerId: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** @returns {number} */
    derbyId() {
      return this.derbyPlayerId.derbyId;
    },

    /** @returns {number} */
    playerId() {
      return this.derbyPlayerId.playerId;
    },

    menuItems() {
      return [
        {
          title: 'Информация',
          route: {name: 'derby_player_info', params: {derbyPlayerId: this.derbyPlayerId}},
          exact: true,
        },
        {
          title: 'Заезды',
          route: {name: 'derby_player_races', params: {derbyPlayerId: this.derbyPlayerId}},
        },
      ];
    },
  },
};
</script>

<style scoped>
.page {
  margin-left: 1rem;
  max-width: 600px;
}

.section-container {
  display: flex;
  align-items: flex-start;
}

.side-nav {
  margin-right: 2rem;
  background-color: rgb(242, 247, 251);
}
</style>
